import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import Footer from "../../components/Footer";

const ThankYouPage: React.FC = () => {
  return (
    <div className="page-wrapper light-bg min-vh-100 d-flex flex-column">
      <div className="content d-flex align-items-center justify-content-center flex-grow-1">
        <div className="card border-0 shadow-sm rounded-4 p-5 text-center max-w-500">
          <div className="mb-4">
            <div className="rounded-circle bg-success bg-opacity-10 d-inline-flex align-items-center justify-content-center" style={{ width: 100, height: 100 }}>
              <i className="ti ti-circle-check text-success" style={{ fontSize: 60 }} />
            </div>
          </div>
          <h2 className="fw-bold text-dark mb-3">Application Received!</h2>
          <p className="text-muted mb-4 fs-5">
            Thank you for applying. We have received your application and will review it shortly. You will receive an email confirmation with your application tracking link.
          </p>
          <div className="d-flex gap-3 justify-content-center">
            <Link to="/" className="btn btn-primary rounded-pill px-4 py-2 fw-medium">
              Go to Homepage
            </Link>
            <Link to={all_routes.careerPagePublic} className="btn btn-outline-primary rounded-pill px-4 py-2 fw-medium">
              View More Jobs
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ThankYouPage;
